import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from '../../ui/Reveal';
import { myths } from '../../../data/offer';
export function MythTable() {
  return <div className="mt-20" data-id="element-172" data-mp="2a2bpqqlvmyml">
      <Reveal data-id="element-173" data-mp="2a1if3ejsroz6">
        <h3 className="max-w-3xl text-[1.5rem] font-extrabold leading-[1.15] tracking-tight text-forest sm:text-3xl" data-id="element-174" data-mp="2a1a3dpzeuppk">
          Te han mentido sobre la nutrición
        </h3>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-body" data-id="element-175" data-mp="204ni50369wn0">
          Es hora de que veas lo que la ciencia realmente dice.
        </p>
      </Reveal>

      <Reveal delay={0.08} data-id="element-176" data-mp="1v7dw7uezs33x">
        <div className="mt-8 overflow-hidden rounded-2xl border border-forest/10" data-id="element-177" data-mp="1r2xpjqxk0rnn">
          <div className="grid grid-cols-2" data-id="element-178" data-mp="1m4crny5ryk2d">
            <p className="flex items-center gap-2 bg-alert-wash px-4 py-3 text-xs font-extrabold uppercase tracking-[0.1em] text-alert-deep sm:px-6 sm:text-sm" data-id="element-179" data-mp="1m5o38k5gow41">
              <XIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-180" data-mp="3ging45igjc7m" />
              Lo que nos dijeron
            </p>
            <p className="flex items-center gap-2 bg-forest px-4 py-3 text-xs font-extrabold uppercase tracking-[0.1em] text-gold sm:px-6 sm:text-sm" data-id="element-181" data-mp="2nql6ognf4yoo">
              <CheckIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-182" data-mp="2snl3e0ydop34" />
              La realidad científica
            </p>
          </div>

          <ul data-id="element-183" data-mp="2johl2z71cdpo">
            {myths.map((row, index) => <li key={row.myth} className={`grid grid-cols-2 ${index % 2 === 0 ? 'bg-white' : 'bg-mist'}`} data-id="element-184" data-mp="2jpj4ps24a8j0" data-mpi={index}>
                <p className="border-r border-forest/10 px-4 py-5 text-sm leading-relaxed text-muted line-through decoration-alert/70 sm:px-6 sm:text-base" data-id="element-185" data-mp="37gybpy4u9e0l">
                  {row.myth}
                </p>
                <p className="px-4 py-5 text-sm font-semibold leading-relaxed text-ink sm:px-6 sm:text-base" data-id="element-186" data-mp="2xn7qr37x7lpn">
                  {row.reality}
                </p>
              </li>)}
          </ul>
        </div>
      </Reveal>
    </div>;
}